import {
  createStore,
  combineReducers,
  applyMiddleware,
} from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { all } from "redux-saga/effects";

import LoginReducer, { watchLoginSaga } from "./login";
import NutStatReducer from "./nutstat";
import NutritionReducer, { watchNutritionSaga } from "./nutrition";
import ForgetPasswordReducer, {
  watchforgetPasswordSaga,
} from "./forgetPassword";
import ResetPasswordReducer, { watchResetPasswordSaga } from "./resetPassword";
import ChangePasswordReducer, {
  watchChangePasswordSaga,
} from "./changePassword";
import AuthReducer, { watchAuthSaga } from "./auth";
import InformReducer, { watchInformSaga } from "./inform";
import ReportReducer, { watchReportSaga } from "./report";
import EditProfileReducer, { watchEditProfileSaga } from "./editProfile";
import ConfirmationReducer, { watchConfirmationSaga } from "./confirmation";
import GenCodePasswordReducer, {
  watchGenCodePasswordSaga,
} from "./genCodePassword";

const sagaMiddleware = createSagaMiddleware();

const reducers = combineReducers({
  login: LoginReducer,
  nutstat: NutStatReducer,
  nutrition: NutritionReducer,
  forgetPassword: ForgetPasswordReducer,
  resetPassword: ResetPasswordReducer,
  changePassword: ChangePasswordReducer,
  auth: AuthReducer,
  inform: InformReducer,
  report: ReportReducer,
  editProfile: EditProfileReducer,
  confirmation: ConfirmationReducer,
  genCodePassword: GenCodePasswordReducer,
});

const store = createStore(reducers, applyMiddleware(sagaMiddleware));

function* rootSaga() {
  yield all([
    watchLoginSaga(),
    watchNutritionSaga(),
    watchforgetPasswordSaga(),
    watchResetPasswordSaga(),
    watchChangePasswordSaga(),
    watchAuthSaga(),
    watchInformSaga(),
    watchReportSaga(),
    watchEditProfileSaga(),
    watchConfirmationSaga(),
    watchGenCodePasswordSaga(),
  ]);
}

sagaMiddleware.run(rootSaga);

export default store;
